import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import cloneDeep from 'lodash/cloneDeep';
import { injectIntl, intlShape } from 'react-intl';
import Loader from '../spinner';
import css from './index.scss';
import StudentDetail from '../../components/student-details/index';
import StudentClassDetail from '../../components/student-class-detail/index';
import Button from '../button/index';
import messages from './messages';
import { invalidCharaters } from '../../helpers/utils';

class EditStudent extends Component {
    constructor(props) {
        super(props);
        this.state = { canSubmit: false };
        this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
    }

    validateStudentModel = () => {
        if (this.props.student.firstName.trim() !== ''
            && this.props.student.lastName.trim() !== ''
            && this.props.student.yearGroupEnum !== '-1'
            && this.props.student.password.trim() !== '') {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }
    }

    handleTextInputOnChange = (event) => {
        const regex = new RegExp(invalidCharaters());
        const value = event.target.value;
        const field = event.target.name;
        if (value !== '' && !regex.test(value)) {
            event.preventDefault();
            return false;
        }

        this.props.student[field] = value;
        this.validateStudentModel(this.props.student);
        return true;
    }

    handleListOnChange = (field, value) => {
        this.props.student[field] = value;
        this.validateStudentModel(this.props.student);
    }

    handleOnSubmit = () => {
        this.setState({ canSubmit: false });
        this.props.handleOnEditStudentSubmit();
    }

    handleOnCloseValidationModal = () => {
        this.setState({ canSubmit: true });
        this.props.closeEditStudentValidationModal();
    }

    render() {
        let clonedYearGroup = [];
        if (this.props.dataFilterOptions) {
            clonedYearGroup = cloneDeep(this.props.dataFilterOptions.yearGroups);
            clonedYearGroup[0].value = this.props.intl.formatMessage(messages.yearGroupList);
        }

        const editStudentView = this.props.isLoadingEditStudentDetail === false
            ? (<div className={this.props.css.editStudent}>
                <div className={this.props.css.studentName}>{this.props.student.firstName}  {this.props.student.lastName}</div>
                <div className={this.props.css.studentDetails}>
                    <StudentDetail
                        downloadStudentsSignInCards={this.props.downloadStudentsSignInCards}
                        editStudentValidationMessage={this.props.editStudentValidationMessage}
                        handleOnCloseModal={this.props.handleOnCloseModal}
                        handleOnCloseValidationModal={this.handleOnCloseValidationModal}
                        handleOnListChange={this.handleListOnChange}
                        handleOnPrintSignInCard={this.props.handleOnPrintSignInCard}
                        handleOnTextInputChange={this.handleTextInputOnChange}
                        isSignInCardDownloaded={this.props.isSignInCardDownloaded}
                        showEditStudentValidationModal={this.props.showEditStudentValidationModal}
                        showModal={this.props.showModal}
                        student={this.props.student}
                        yearGroups={clonedYearGroup}
                    />
                </div>
                <div className={this.props.css.classDetails}>
                    <StudentClassDetail
                        editStudentDetail={this.props.editStudentDetail}
                        handleOnAssignClass={this.props.handleOnAssignClass}
                        handleOnCloseModal={this.props.handleOnCloseModal}
                        handleOnUnassignConfirm={this.props.handleOnUnassignConfirm}
                        handleOnUnassignStudent={this.props.handleOnUnassignStudent}
                        isLoading={this.props.isLoading}
                        isUnassignedModalOpen={this.props.isUnassignedModalOpen}
                        productName={this.props.productName}
                        showUnassignStudentModal={this.props.showUnassignStudentModal}
                        unassignStudentsSuccessConfirmation={this.props.unassignStudentsSuccessConfirmation} />
                </div>
                <div className={this.props.css.studentFooter}>
                    <div className={this.props.css.buttonContainer}>
                        <Button
                            containerClassName={this.props.css.cancelButton}
                            disabled={this.props.updatingStudent}
                            handleOnClick={this.props.closeEditStudent}
                            label={this.props.intl.formatMessage((messages.cancel))} />
                        <Button
                            containerClassName={this.props.css.saveButton}
                            disabled={!this.state.canSubmit}
                            handleOnClick={this.handleOnSubmit}
                            label={this.props.intl.formatMessage(messages.save)} />
                    </div>
                </div>
            </div>
            )
            : (
                <div className={this.props.css.loader}>
                    <Loader color="grey" size="15px" />
                </div>
            );

        return editStudentView;
    }
}

EditStudent.propTypes = {
    studentName: PropTypes.string,
    updatingStudent: PropTypes.bool,
    css: PropTypes.object,
    student: PropTypes.object,
    dataFilterOptions: PropTypes.object,
    handleOnEditStudentSubmit: PropTypes.func,
    showEditStudentValidationModal: PropTypes.bool,
    editStudentValidationMessage: PropTypes.string,
    closeEditStudentValidationModal: PropTypes.func,
    closeEditStudent: PropTypes.func,
    handleOnPrintSignInCard: PropTypes.func,
    isSignInCardDownloaded: PropTypes.bool,
    productName: PropTypes.string,
    editStudentDetail: PropTypes.object,
    handleOnUnassignStudent: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    handleOnUnassignConfirm: PropTypes.func,
    unassignStudentsSuccessConfirmation: PropTypes.func,
    isUnassignedModalOpen: PropTypes.bool,
    showUnassignStudentModal: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLoadingEditStudentDetail: PropTypes.bool,
    intl: intlShape.isRequired,
    handleOnAssignClass: PropTypes.func,
    showModal: PropTypes.bool,
    downloadStudentsSignInCards: PropTypes.func
};

export default injectIntl(styleable(css)(EditStudent));



// WEBPACK FOOTER //
// ./app/components/edit-student-form/index.js